/** Formatare calorii introduse ca valoare la 100g. */
export function formatCaloriesPer100g(calories, template = '{{n}} kcal / 100g') {
    if (calories == null || calories === '') return null;
    const n = Number(calories);
    if (Number.isNaN(n)) return null;
    return String(template).replace('{{n}}', String(n));
}

/** Formatare calorii introduse ca valoare per porție. */
export function formatCaloriesPerPortion(calories, template = '{{n}} kcal / porție') {
    if (calories == null || calories === '') return null;
    const n = Number(calories);
    if (Number.isNaN(n)) return null;
    return String(template).replace('{{n}}', String(n));
}
